export const translations = {
	'{0} (default)': {},
	'Formula placeholder': {
		en: "Expressions must use 'metric' to represent metric value. Example: metric*100.",
		no: "Uttrykket må bruke 'metric' for å representere metrikkverdi. Eksempel: metric*100.",
	},
	'Formula tooltip': {
		en: 'Formula editor support normal operators (+-/*%^) and functions (cos, sin, log). Check https://www.objecthunter.net/exp4j/#Built-in_functions for more examples',
		no: 'Formel editor støtter normale operatorer (+ - / *% ^) og funksjoner (cos, sin, log). Se https://www.objecthunter.net/exp4j/#Built-in_functions for flere eksempler',
	},
	'Formula is valid': {
		no: 'Formelen er gyldig',
	},
	'Formula is valid. Output is: {0}.': {
		no: 'Formelen er gyldig. resultatet er: {0}.',
	},
	'Formula is not valid': {
		no: 'Formelen er ikke gyldig',
	},
	'Autoscaling': {},
};
